itsoftApp.createModule("picturefill", ["lazyLoadingImages"], function () {
    itsoftApp.loadScript("/assets/scripts/picturefill/picturefill.min.js");
})